import React from "react";

export const NotFound = () => {
  return (
    <div>
      <h1>Its happiness cuz i cant find it 404</h1>
    </div>
  );
};
